import { render, staticRenderFns } from "./carigenelamaclirapor.vue?vue&type=template&id=baea85f2&scoped=true"
import script from "./carigenelamaclirapor.vue?vue&type=script&lang=js"
export * from "./carigenelamaclirapor.vue?vue&type=script&lang=js"
import style0 from "./carigenelamaclirapor.vue?vue&type=style&index=0&id=baea85f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baea85f2",
  null
  
)

export default component.exports